import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'gatsby'
import Button from 'react-bootstrap/Button'

export default function NavButton(props) {
  return (
    <Link to={props.to} className={props.className}>
      <Button className={`m-2 ${props.className}`}>
        <div className="d-flex justify-content-center flex-wrap">
          <span style={{fontSize: '.95rem'}} className="w-100">{props.subtitle}</span>
          <span className="w-100 bold-me">{props.title}</span>
        </div>
      </Button>
    </Link>
  )
}

NavButton.propTypes = {
  to: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}